var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.045,3.251L15,3.25L9,3.25C8.04,3.25 7.25,4.04 7.25,5C7.25,5.686 6.686,6.25 6,6.25L5,6.25C3.491,6.25 2.25,7.491 2.25,9L2.25,18C2.25,19.509 3.491,20.75 5,20.75L19,20.75C20.509,20.75 21.75,19.509 21.75,18L21.75,9C21.75,7.491 20.509,6.25 19,6.25L18,6.25C17.314,6.25 16.75,5.686 16.75,5C16.75,4.055 15.984,3.275 15.045,3.251ZM12,9.25C9.93,9.25 8.25,10.93 8.25,13C8.25,15.07 9.93,16.75 12,16.75C14.07,16.75 15.75,15.07 15.75,13C15.75,10.93 14.07,9.25 12,9.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFilled);
export default __webpack_public_path__ + "static/media/camera_filled.e5a4ec11.svg";
export { ForwardRef as ReactComponent };